import { useEffect, useState } from "react";

const OTP_TIMER = 120;

export const useOtpTimer = () => {
  const [remainingTime, setRemainingTime] = useState(OTP_TIMER);

  useEffect(() => {
    if (remainingTime <= 0) return;

    const timer = window.setInterval(() => {
      setRemainingTime((current) => Math.max(current - 1, 0));
    }, 1000);

    return () => window.clearInterval(timer);
  }, [remainingTime]);

  const resetTimer = () => {
    setRemainingTime(OTP_TIMER);
  };

  return {
    remainingTime,
    resetTimer,
    isExpired: remainingTime === 0,
  };
};
